import "./index.scss";

const CircularLoader = (props) => {
  const {
    message = "Loading...",
    size = "medium",
    messageClassName = "",
    className = "",
  } = props;

  return (
    <div className={`loader-container ${className}`}>
      <div className={`loader-spinner loader-spinner--${size}`}></div>
      {message && (
        <p className={`loader-message ${messageClassName}`}>{message}</p>
      )}
    </div>
  );
};

export default CircularLoader;
